export default __webpack_public_path__ + "static/media/opensea.178b6c9d.svg";